import request, { ResultHandler } from '@/core/utils/request'
const EmailBaseUrl = '/admin/email'

const EmailPassword = 'email_saved_pass'
export const getEmailPassword = () => localStorage.getItem(EmailPassword)
export const setEmailPassword = password =>
  localStorage.setItem(EmailPassword, password)

export const sendVerifyCode = async receiver => {
  const result = await request({
    url: EmailBaseUrl + '/code',
    method: 'POST',
    params: {
      receiver
    }
  })
  return ResultHandler(result, 'Send email code failed!')
}

export const sendEmail = async data => {
  const form = new FormData()
  Object.keys(data).forEach(key => {
    form.append(key, data[key])
  })
  const result = await request({
    url: EmailBaseUrl + '/send',
    headers: {
      'Content-Type': 'multipart/form-data'
    },
    method: 'POST',
    data: form
  })
  return ResultHandler(result, 'Send email failed!')
}

export const testConnection = async (email, password) => {
  const result = await request({
    url: EmailBaseUrl + '/connect',
    params: {
      email,
      password
    },
    method: 'GET'
  })
  return ResultHandler(result, 'Failed to connect')
}
